var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 94,
    viewBox: "0 0 114 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    opacity: 0.1,
    d: "M48.1491 0C49.3292 3.5206 49.9193 6.45443 49.9193 8.80151C49.9193 10.9139 49.5652 13.7303 48.8571 17.2509C33.0435 17.2509 25.1366 25.3483 25.1366 41.5431C25.1366 47.4107 28.205 50.6966 34.3416 51.4008C43.3106 52.1049 47.795 57.8552 47.795 68.6517C47.795 76.8664 45.7888 83.2035 41.7764 87.6629C38 91.8876 31.0373 94 20.8882 94C6.96273 94 0 84.6117 0 65.8352C0 47.0587 3.7764 31.4507 11.3292 19.0112C18.882 6.33708 31.1553 0 48.1491 0ZM112.23 0C113.41 3.5206 114 6.45443 114 8.80151C114 10.9139 113.646 13.7303 112.938 17.2509C97.1242 17.2509 89.2174 25.3483 89.2174 41.5431C89.2174 47.4107 92.2857 50.6966 98.4224 51.4008C107.391 52.1049 111.876 57.8552 111.876 68.6517C111.876 76.8664 109.87 83.2035 105.857 87.6629C102.081 91.8876 95.118 94 84.9689 94C71.0435 94 64.0807 84.6117 64.0807 65.8352C64.0807 47.0587 67.8571 31.4507 75.4099 19.0112C82.9627 6.33708 95.236 0 112.23 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteImg);
export default __webpack_public_path__ + "static/media/QuoteImg.20c0f84332c3b6bc042ce2a0dc822ae3.svg";
export { ForwardRef as ReactComponent };